import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Title1 from '@joinforma/ui/components/Title1';
import { ReactComponent as DigitalSvg } from 'assets/images/icons/explore/watch.svg';
import { ReactComponent as GymSvg } from 'assets/images/icons/explore/gym.svg';
import { ReactComponent as FamilySvg } from 'assets/images/icons/explore/family.svg';
import { ReactComponent as FoodSvg } from 'assets/images/icons/explore/utensils.svg';
import { ReactComponent as WellbeingSvg } from 'assets/images/icons/explore/meditation.svg';

import { StoreRoutes } from 'utils/routeGenerator';

import { CategoryId, TARGET_CATEGORIES_MAP } from 'constants/categories';
import { STORE_LAYOUT_ELEMENTS } from 'constants/testSelectors';

const CategoryCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 878px;
  margin: 0 1px; // this allows the box shadow to show when screen is less than min-width
`;

const Container = styled.div`
  position: absolute;
  top: 220px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const CategoryCard = styled(Link)`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 119px;
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.08);
  border-radius: 7px;
  padding: 20px;
  cursor: pointer;
`;

const CategoryName = styled(Title1)``;

const CategoryIconContainer = styled.div``;

const getIcon = ({ category_id }: { category_id: string }) => {
  switch (category_id) {
    case CategoryId.DIGITAL_HEALTH:
      return <DigitalSvg />;
    case CategoryId.FITNESS_ACTIVITIES:
      return <GymSvg />;
    case CategoryId.CAREGIVING:
      return <FamilySvg />;
    case CategoryId.FOOD_SERVICES:
      return <FoodSvg />;
    case CategoryId.WELLBEING_SERVICES:
      return <WellbeingSvg />;
    default:
      return null;
  }
};

const CategoryCards = ({
  categories,
  employee_wallet_id,
  onCategoryCardClick,
}: {
  categories: {
    id: string;
    name: string;
    alias?: string;
  }[];
  employee_wallet_id: string;
  onCategoryCardClick: ({
    event,
    category_filter,
  }: {
    event: React.MouseEvent;
    category_filter: string;
  }) => void;
}) => (
  <Container data-testid={STORE_LAYOUT_ELEMENTS.STORE_BANNER_CATEGORY_CARDS}>
    <CategoryCardsContainer>
      {categories.map((category) => (
        <CategoryCard
          key={category.id}
          onClick={(event) => {
            const category_filter = category.alias ?? category.name;
            onCategoryCardClick({ event, category_filter });
          }}
          to={StoreRoutes.categoryLanding({
            alias: category.alias ? category.alias : category.id,
            categoryId: category.id,
            walletId: employee_wallet_id,
          })}
        >
          <CategoryIconContainer>
            {getIcon({ category_id: category.id })}
          </CategoryIconContainer>
          <CategoryName>
            {TARGET_CATEGORIES_MAP[category.id].label}
          </CategoryName>
        </CategoryCard>
      ))}
    </CategoryCardsContainer>
  </Container>
);

export default CategoryCards;
